/**
 * Lenavio Connect — Slack integration API client.
 *
 * Mirrors ``backend/app/routers/integrations_slack.py``. The
 * install endpoint returns a JSON authorize URL; the SPA does
 * ``window.location.href = authorize_url`` to follow it.
 */
import client from "./client";

export interface SlackInstallResponse {
  authorize_url: string;
}

export interface SlackStatusResponse {
  connected: boolean;
  workspace_id: string | null;
  workspace_name: string | null;
  bot_user_id: string | null;
  installed_at: string | null;
  /** Channel outbound notifications post to. Null until configured. */
  notify_channel_id: string | null;
}

export async function getSlackInstallUrl(): Promise<SlackInstallResponse> {
  const res = await client.get<SlackInstallResponse>("/integrations/slack/install");
  return res.data;
}

export async function getSlackStatus(): Promise<SlackStatusResponse> {
  const res = await client.get<SlackStatusResponse>("/integrations/slack/status");
  return res.data;
}

export async function disconnectSlack(): Promise<SlackStatusResponse> {
  const res = await client.delete<SlackStatusResponse>(
    "/integrations/slack/disconnect",
  );
  return res.data;
}

/**
 * Set (or clear, with an empty string) the channel that outbound
 * notifications broadcast to. The bot must already be a member of the
 * channel — Slack rejects posts to channels it hasn't joined.
 */
export async function setSlackChannel(
  channelId: string,
): Promise<SlackStatusResponse> {
  const res = await client.put<SlackStatusResponse>(
    "/integrations/slack/channel",
    { channel_id: channelId },
  );
  return res.data;
}
